
import React from "react";
import "./LogoutModel.css";
import { useTranslation } from "react-i18next";

type LogoutModelProps = {
  open: boolean;
  title?: string;
  subtitle?: string;
  showSpinner?: boolean;
};

const overlayStyles: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyles: React.CSSProperties = {
  background: "#fff",
  padding: "24px 28px",
  borderRadius: 12,
  minWidth: 320,
  textAlign: "center",
  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
};

const spinnerStyles: React.CSSProperties = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  border: "4px solid #eee",
  borderTop: "4px solid #1976d2",
  animation: "spin 0.9s linear infinite",
  margin: "0 auto",
};

const LogoutModel: React.FC<LogoutModelProps> = ({
  open,
  title,
  subtitle,
  showSpinner = true,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  const finalTitle = title || t("logoutModel.title");
  const finalSubtitle = subtitle || t("logoutModel.subtitle");

  return (
    <div style={overlayStyles} role="dialog" aria-modal="true" aria-live="assertive">
      <div style={modalStyles}>
        {showSpinner && <div style={spinnerStyles} aria-hidden />}
        <h2 style={{ marginTop: 12, fontSize: 18, fontWeight: 700 }}>
          {finalTitle}
        </h2>
        <p style={{ marginTop: 6, fontSize: 13, opacity: 0.8 }}>
          {finalSubtitle}
        </p>
      </div>
    </div>
  );
};

export default LogoutModel;
